import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import CustomForm from "../../../components/CustomForm/CustomForm";

const CreateRoutinePeriod = () => {
  const initialFormData = {
    effectiveFrom: "",
    effectiveTo: "",
    enrollmentSetupId: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [enrollment, setEnrollments] = useState([]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const fetchEnrollment = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/enrollmentSetup/list`
        );
        setEnrollments(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchEnrollment();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/routinePeriod/create`, {
          effectiveFrom: formData.effectiveFrom,
          effectiveTo: formData.effectiveTo,
          enrollmentSetupId: formData.enrollmentSetupId,
        }),
        {
          pending: "Processing your request",
        }
      );
      toast.success(response.data.message);
      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "enrollmentSetupId",
      label: "Enrollment",
      type: "select",
      value: formData.enrollmentSetupId,
      onChange: handleChange,
      options: [
        { label: "Select Enrollment", value: "" },
        ...enrollment.map((p) => ({
          label: p.enrollmentBatch,
          value: p.id,
        })),
      ],
    },
    {
      name: "effectiveFrom",
      label: "Effective From",
      type: "date",
      value: formData.effectiveFrom,
      onChange: handleChange,
    },
    {
      name: "effectiveTo",
      label: "Effective To",
      type: "date",
      value: formData.effectiveTo,
      onChange: handleChange,
    },
  ];
  return (
    <div>
      <CustomForm
        header="Create Routine Period"
        fields={fields}
        flexDirection="column"
        createButtonLabel="Create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default CreateRoutinePeriod;
